import pj from '../../package.json'

class Config {
  static version = pj.version
  static companySequence = '.ap.iO.Oe.eT.tP.vHIqv.mI.xd.5WIJ'
  static systemSequence = '.&70o}.?F'
  static japanEps = [76, 77, 78, 80]
}
export default Config